/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useRef, useState } from 'react'
import {
  Animated,
  LayoutAnimation,
  Platform,
  TouchableOpacity,
  ActivityIndicator,
  View,
  Keyboard,
  Dimensions,
  Pressable,
  useWindowDimensions
} from 'react-native'
import PropTypes from 'prop-types'
import {
  Icon,
  VFButton,
  VFInput,
} from '@vfgroup-oneplatform/foundation/Components'
import Geolocation from '@react-native-community/geolocation'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Modal from '../../Components/Modal'

import { Colors, withTheme, LightThemeColors, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeColors } from '../../Themes'

import VfText from '../../Components/VfText'

import styles from './PurchaseCoverage.Styles'
import Images from '../../Themes/Images'

import _Modal from 'react-native-modal'

import { MapWrapper } from './Map'
import { getCoveredAreas } from '../../../../../App/Services/Unlimited'
import axios from 'axios'


const INITIAL_REGION = {
  latitude: 41.3275,
  longitude: 19.8187,
  latitudeDelta: 0.015,
  longitudeDelta: 0.0121,
}
const LOCATION_ERRORS = {
  PERMISSION_DENIED: 'giga_bonus_error_permission_denied',
  POSITION_UNAVAILABLE: 'giga_bonus_error_position_unavailable',
  TIMEOUT: 'giga_bonus_error_location_timeout',
}

const DEFAULT_LOCATION_ERROR = 'giga_bonus_error_position_unavailable'

// const LOCATION_PERMISSION = Platform.OS === 'ios' ? PERMISSIONS.IOS.LOCATION_WHEN_IN_USE : PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION

const SCREEN_HEIGHT = Dimensions.get('window').height



export const LocationSelector = memo(function Maps({
  currentCoordinates,
  updateCoordinates,
  updateCurrentCoordinates,
  goToSteps,
  inputRef,
  onSearch,
  successSearch,
  geographicAddressLoading,
  geographicAddress,
  validationAddressLoading,
  API_KEY,
  theme,
  isContentLoading,
  isErrorSearch,
  onCancelNotifyMe,
  toggleModal,
  serviceAreas,
  setServiceAreas,
  areItemsFetching,
  setSuccessSearch,
  setAreItemsFetching,
  validateLocation,
  streetName,
  setStreetName
}) {

  const [isMapLoading, setIsMapLoading] = useState(false)

  const [locationError, setLocationError] = useState({
    isVisible: false,
    message: '',
  })
  const region = useRef(INITIAL_REGION)
  const location = useRef(new Animated.Value(0)).current


  const marker = useRef()
  const map = useRef()

  const animate = nextProps => {
    location.timing({ ...nextProps, duration: 300 }).start()
    map.current?.animateToRegion({ ...nextProps }, 0.5)

    onRegionChangeComplete(nextProps)
  }

  const getOffers = async (coords, locationAddress) => {
    await onSearch(coords, locationAddress)
  }

  const onMapPress = ({ nativeEvent: { coordinate } }) => {

    updateCoordinates(coordinate)
    animate({ ...region.current, ...coordinate })
    getOffers(coordinate)
  }

  const onMarkerDragEnd = ({ nativeEvent: { coordinate } }) => {
    updateCoordinates(coordinate)
    const newCoordinates = { ...region.current, ...coordinate }
    location.setValue(newCoordinates)
    map.current?.animateToRegion(newCoordinates)
  }

  const onRegionChangeComplete = newRegion => {
    region.current = newRegion
  }

  const locate = () => {
    setIsMapLoading(true)
    Geolocation.getCurrentPosition(
      ({ coords }) => {

        setLocationError({
          isVisible: false,
          message: '',
        })
        updateCurrentCoordinates(coords)

        map.current?.animateToRegion({ ...region.current, ...coords })

        onRegionChangeComplete({ ...region.current, ...coords })

        setIsMapLoading(false)
      },
      (e) => {

        const error = Object.keys(e).find(item => e[item] === e.code && item !== 'code')
        setLocationError({
          isVisible: true,
          message: LOCATION_ERRORS[error] || DEFAULT_LOCATION_ERROR,
        })

        //when permission is denied then we update coordinates to a default location
        updateCurrentCoordinates({
          latitude: INITIAL_REGION.latitude,
          longitude: INITIAL_REGION.longitude,
          latitudeDelta: 0.015,
          longitudeDelta: 0.0121,
        })

        setIsMapLoading(false)
      },
      //enableHighAccuracy if its true it will use gps location and it can stay for a long period loading or may timeout else it will use wifi location
      { enableHighAccuracy: false, },
    )
  }


  //set map coordinates and pin to selected search suggestion
  const search = (description, geometry) => {

    const { lat, lng } = geometry.location

    const newRegion = {
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      latitudeDelta: 0.015,
      longitudeDelta: 0.0121,
    }

    updateCoordinates(newRegion)
    animate({ ...region.current, ...newRegion })

    getOffers(newRegion)

    inputRef?.current?.setValue(description)
    inputRef?.current?.blur()
  }

  const pinToCurrentLocation = () => { }

  const themeColors = getThemeColors(theme.name)

  const showMarker = (location?.latitude === null) && (location?.longitude === null)

  const latlng = useRef({
    lat: null,
    lng: null
  })

  const getCoveragePolygons = city => {
    getCoveredAreas({
      body: { city },
      onStart: () =>
        setAreItemsFetching(true),
      onError: () =>
        setAreItemsFetching(false),
      onSuccess: data => {
        setAreItemsFetching(false)
        setServiceAreas(data)
      }
    })
  }

  const getCityName = async () => {
    try {
      const { data } = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng.current.lat},${latlng.current.lng}&sensor=true&key=AIzaSyDgZm5OUSqiyK7fEstVVKhQCtQvkEvXjZo`)
      data?.results?.map(item => {
        if (item?.types[0] === "administrative_area_level_1") {
          getCoveragePolygons(item?.formatted_address.split(' ')[0]?.replace('ë', 'e') + '')
        }
      })
    } catch (error) {
      console.log("🚀 ~ file: CoverageScreen.js:130 ~ getCityName ~ error:", error)
    }
  }

  const getRoadName = async ({ lat, lng }) => {
    try {
      const { data } = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyDgZm5OUSqiyK7fEstVVKhQCtQvkEvXjZo`)
      data?.results?.map(item => {
        if (item?.types[0] === "route") {
          setStreetName(item?.formatted_address)
        }
      })
    } catch (error) {
      console.log("🚀 ~ file: CoverageScreen.js:130 ~ getCityName ~ error:", error)
    }
  }

  const onMapShow = () => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      latlng.current = {
        lat: coords.latitude,
        lng: coords.longitude
      }
      getCityName()
    }, (e) => {
      latlng.current = {
        lat: 41.3275,
        lng: 19.8187
      }
      getCityName()
    }, { timeout: 10000 })
  }

  return (
    <View style={{ marginTop: 20, flex: 1 }} >
      <MapWrapper
        onSearch={onSearch}
        serviceAreas={serviceAreas}
        setServiceAreas={setServiceAreas}
        areItemsFetching={areItemsFetching}
        theme={theme}
        isErrorSearch={isErrorSearch}
        successSearch={successSearch}
        goToSteps={goToSteps}
        onCancelNotifyMe={onCancelNotifyMe}
        toggleModal={toggleModal}
        NoCover={NotifyMeModalContent}
        setSuccessSearch={setSuccessSearch}
        onMapShow={onMapShow}
        UnlimitedHome={true}
        validateLocation={validateLocation}
        streetName={streetName}
        getRoadName={getRoadName}
      />
    </View>
  )
})
LocationSelector.defaultProps = {
  updateCoordinates: () => { },
}
LocationSelector.propTypes = {
  currentCoordinates: PropTypes.object,
  updateCoordinates: PropTypes.func,
  goToSteps: PropTypes.func,
  onSearch: PropTypes.func,
  successSearch: PropTypes.bool,
  street: PropTypes.string,
  setStreet: PropTypes.func,
  inputRef: PropTypes.object,
  API_KEY: PropTypes.string,
  theme: PropTypes.object,
  isContentLoading: PropTypes.bool,
}


const NotifyMeModalContent = ({ onCancelNotifyMe, theme }) => {
  return (
    <View style={styles.notifyContainer(theme)}>
      <VfText
        weight="regular"
        size="h3"
        align="left"
        i18nKey="notify_me_subtitle"
        style={styles.descText}
        color={theme.colors.textColor}
      />
      <VfText
        weight="regular"
        size="body"
        align="left"
        color={theme.colors.textColorTwo}
        i18nKey="notify_me_desc"
        style={styles.descText}
      />
      <VFButton
        type="secondary"
        title="notify_me_cancel_button_label"
        style={{ marginTop: 20 }}
        onPress={onCancelNotifyMe}
      />
    </View>
  )
}

function PurchaseCoverage({
  isVisible,
  toggleModal,
  goToSteps,
  onSearch,
  geographicAddress,
  geographicAddressLoading,
  validationAddressLoading,
  locationState,
  API_KEY,
  theme,
  inputRef,
  isContentLoading,
  serviceAreas,
  setServiceAreas,
  areItemsFetching,
  validateLocation,
  setAreItemsFetching,
  streetName,
  setStreetName
}) {

  const {
    currentCoordinates,
    setCoordinates,
    setCurrentCoordinates,
    successSearch,
    isErrorSearch,
    setIsErrorSearch,
    setSuccessSearch
  } = locationState

  const [isKeyboardVisible, setKeyboardVisible] = useState(false)

  const insets = useSafeAreaInsets()
  const themeImages = getThemeImages(theme.name)


  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener(
      'keyboardDidShow',
      () => {
        setKeyboardVisible(true)
      }
    )
    const keyboardDidHideListener = Keyboard.addListener(
      'keyboardDidHide',
      () => {
        setKeyboardVisible(false)
      }
    )

    return () => {
      keyboardDidHideListener.remove()
      keyboardDidShowListener.remove()
    }
  }, [])

  const updateCoordinates = latlng => {
    const { latitude, longitude } = latlng
    setCoordinates(latitude + ',' + longitude)
  }

  const updateCurrentCoordinates = latlng => {
    const { latitude, longitude } = latlng
    setCurrentCoordinates(latitude + ',' + longitude)
  }

  const onCancelNotifyMe = () => {
    LayoutAnimation.configureNext({
      duration: 300,
      create:
      {
        type: LayoutAnimation.Types.easeInEaseOut,
        property: LayoutAnimation.Properties.opacity,
      },
      update:
      {
        type: LayoutAnimation.Types.easeInEaseOut,
      }
    })
    setIsErrorSearch(false)
  }

  const LoadingIndicator = ({ show, extraStyles }) => {
    const { height } = useWindowDimensions()

    const loader = height => ({
      zIndex: 1,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      height: height * (Dimensions.get('window').width > 700 ? 0.5 : 0.75),
      justifyContent: 'center'
    })

    if (!show) {
      return null
    }

    return (
      <View style={[loader(height), extraStyles]}>
        <ActivityIndicator size={50} color={Colors.red} />
      </View>
    )
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <_Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={() => { toggleModal(false) }}
        onBackdropPress={() => { toggleModal(false) }}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View style={{
          minWidth: 600,
          minHeight: 600,
          backgroundColor: theme.colors.quickActionGradientColors.secondary,
          margin: 'auto',
          padding: '20px',
          borderRadius: "7px",
        }}>
          <View style={styles.header} >
            <VfText
              weight="bold"
              size="h3"
              align="left"
              color={theme.colors.textColor}
              i18nKey="renewals_verify_coverage"
            />
            <TouchableOpacity onPress={() => toggleModal(false)} >
              <Icon
                name={themeImages.ic_close}
                size={25}
                resizeMode='contain'
              />
            </TouchableOpacity>
          </View>

          <VfText
            weight="regular"
            size="body"
            align="left"
            color={theme.colors.textColorTwo}
            i18nKey="renewals_verify_coverage_desc"
            style={styles.descText}
          />
          <LocationSelector
            currentCoordinates={currentCoordinates}
            updateCoordinates={updateCoordinates}
            updateCurrentCoordinates={updateCurrentCoordinates}
            goToSteps={goToSteps}
            inputRef={inputRef}
            onSearch={onSearch}
            successSearch={successSearch}
            geographicAddress={geographicAddress}
            geographicAddressLoading={geographicAddressLoading}
            validationAddressLoading={validationAddressLoading}
            API_KEY={API_KEY}
            theme={theme}
            isContentLoading={isContentLoading}
            isErrorSearch={isErrorSearch}
            onCancelNotifyMe={onCancelNotifyMe}
            toggleModal={toggleModal}
            serviceAreas={serviceAreas}
            setServiceAreas={setServiceAreas}
            areItemsFetching={areItemsFetching}
            setSuccessSearch={setSuccessSearch}
            setAreItemsFetching={setAreItemsFetching}
            validateLocation={validateLocation}
            streetName={streetName}
            setStreetName={setStreetName}
          />
          <LoadingIndicator show={areItemsFetching} extraStyles={{ display: 'flex', justifyContent: 'center' }} />
        </View>
      </_Modal>
    )
  }

  return (
    <Modal
      visible={isVisible}
      close={() => { toggleModal(false) }}
    >
      <View style={{ height: Dimensions.get('window').height * 0.8, padding: 20, backgroundColor: theme.colors.quickActionGradientColors.secondary }} >
        <View style={styles.modalContentWraper(theme)}>
          <>
            <View style={styles.header} >
              <VfText
                weight="bold"
                size="h3"
                align="left"
                color={theme.colors.textColor}
                i18nKey="renewals_verify_coverage"
              />
              <TouchableOpacity onPress={() => { toggleModal(false) }} >
                <Icon
                  name={themeImages.ic_close}
                  size={25}
                  resizeMode='contain'
                />
              </TouchableOpacity>
            </View>

            <VfText
              weight="regular"
              size="body"
              align="left"
              color={theme.colors.textColorTwo}
              i18nKey="renewals_verify_coverage_desc"
              style={styles.descText}
            />
            <LocationSelector
              currentCoordinates={currentCoordinates}
              updateCoordinates={updateCoordinates}
              updateCurrentCoordinates={updateCurrentCoordinates}
              goToSteps={goToSteps}
              inputRef={inputRef}
              onSearch={onSearch}
              successSearch={successSearch}
              geographicAddress={geographicAddress}
              geographicAddressLoading={geographicAddressLoading}
              validationAddressLoading={validationAddressLoading}
              API_KEY={API_KEY}
              theme={theme}
              isContentLoading={isContentLoading}
              isErrorSearch={isErrorSearch}
              onCancelNotifyMe={onCancelNotifyMe}
              toggleModal={toggleModal}
              serviceAreas={serviceAreas}
              setServiceAreas={setServiceAreas}
              areItemsFetching={areItemsFetching}
              setSuccessSearch={setSuccessSearch}
              setAreItemsFetching={setAreItemsFetching}
              validateLocation={validateLocation}
              streetName={streetName}
              setStreetName={setStreetName}
            />
            <LoadingIndicator show={areItemsFetching} extraStyles={{ display: 'flex', justifyContent: 'center' }} />
          </>
        </View>
      </View>
    </Modal>
  )
}

PurchaseCoverage.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors,
  }
}

PurchaseCoverage.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  goToSteps: PropTypes.func,
  coordinates: PropTypes.any,
  setCoordinates: PropTypes.func,
  street: PropTypes.string,
  setStreet: PropTypes.func,
  onSearch: PropTypes.func,
  isErrorSearch: PropTypes.bool,
  successSearch: PropTypes.bool,
  setIsErrorSearch: PropTypes.func,
  API_KEY: PropTypes.string,
  theme: PropTypes.object,
  inputRef: PropTypes.object,
  isContentLoading: PropTypes.bool,
}

export default withTheme(PurchaseCoverage)
